import React from "react";
import styled from "styled-components";

const StyledCopyright = styled.section`
  margin-top: 32px;
  text-align: center;
  width: 100%;
  p {
    color: #cdd9e0;
  }
`;

const Copyright = () => (
  <StyledCopyright>
    <p>2017 Rob McMackin</p>
  </StyledCopyright>
);

export default Copyright;



// WEBPACK FOOTER //
// ./src/components/copyright.jsx